export class AppDebug {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
}
/*
private spyer = spy(event => {

    if (!this.spy) return;

    if (event.type === 'update') {
        console.log('update', event.object, event.name || event.index, event.oldValue, event.newValue);
    }

    if (event.type === 'add') {
        console.log('add', event.object, event.name, event.newValue);
    }

    if (event.type === 'create') {
        console.log('create', event.object, event.newValue);
    }

    if (event.type === 'delete') {
        console.log('delete', event.object, event.name, event.oldValue);
    }

    if (event.type === 'splice') {
        console.log('splice', event.object, event.index, event.added, event.removed, event.addedCount, event.removedCount);
    }

    if (event.type === 'error') {
        console.log('mobx error', event.message);
    }

    if (event.type === 'action') {
        // console.log(`${event.name} with args: ${event.arguments}`);
    }

    if (event.type === 'scheduled-reaction') {
        // console.log(`${event.name} with args: ${event.arguments}`)
        console.log(`${event.object} `);
    }
});
*/
